module.exports = __webpack_public_path__ + "static/013-715a5336eb4b8d548ffc5cebf851172f.jpg";